import React, { useContext } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useGuestContext } from "../../../contexts/GuestContext";

const LanguageToggle = () => {
    const { language,toggleLanguage } = useGuestContext();

    return (
        <Row className="mb-3">
            <Col md={{ span: 10, offset: 1 }} className="d-flex align-items-center justify-content-between">
                <span className="description"> {language === "English" ? "Page Language" : "頁面語言"}</span>
                <div className="d-flex align-items-center justify-content-center mb-2">
                <label className="mb-0">
                        <span className={`mr-2 mb-0 ${language === 'Chinese' ? "text-warning font-weight-bold" : ""}`}>
                            中文
                        </span>
                    </label>
                    <Form.Check
                        type="switch"
                        id="language"
                        checked={language === 'English'}
                        onChange={toggleLanguage}
                    />
                   
                    <label className="mb-0">
                        <span className={`ml-2 ${language === 'English' ? "text-warning font-weight-bold" : ""}`}>
                            English
                        </span>
                    </label>
                </div>
            </Col>
        </Row>
    );
};

export default LanguageToggle;
